// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"296":"4e1b5566","481":"6672a8f2","751":"f3ee4fd7","785":"94b461a1","787":"51b4718b"}[chunkId] + ".chunk.js";
};